import { DEFAULT_TRANSPORT_TYPE } from '@apps/main/modules/helpers/transports';

import { assertValue } from '@libs/utils';

import { FLEXIBLE_NUMBER_OF_NIGHTS_SYMBOL } from './constants';

export function deserializeNumberOfNights(
  serializedNumberOfNights: string
): number | undefined {
  if (serializedNumberOfNights !== FLEXIBLE_NUMBER_OF_NIGHTS_SYMBOL) {
    const numberOfNights = parseInt(serializedNumberOfNights, 10);
    if (!isNaN(numberOfNights)) {
      return numberOfNights;
    }
  }
}

export function deserializeTransportType(props: string): number {
  const firstValue = props[0];
  const secondValue = props[1];
  assertValue(
    firstValue,
    'hotelSerializer.ts > deserializeTransportType > firstValue'
  );
  assertValue(
    secondValue,
    'hotelSerializer.ts > deserializeTransportType > secondValue'
  );

  const result = parseInt(firstValue + secondValue, 10);

  if (isNaN(result)) {
    return DEFAULT_TRANSPORT_TYPE;
  }

  return result;
}
